var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.618 69.494c.153.153.35.229.552.229.2 0 .399-.076.551-.229l29.25-29.25a.78.78 0 000-1.103l-29.25-29.25a.78.78 0 10-1.103 1.103l28.699 28.699L24.618 68.39a.78.78 0 000 1.103z","fill":"#000"}));
}

Arrow.defaultProps = {"width":"79","height":"79","viewBox":"0 0 79 79","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
